import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createStaticVNode as _createStaticVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"


export default /*@__PURE__*/_defineComponent({
  __name: 'StatusPill',
  props: {
    text: {
        type: String,
        default: null,
    },
    color: {
        type: String, // blue
        default: null,
    }
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: _normalizeClass(["inline-flex items-center justify-center text-xs font-bold px-2 py-0.5 rounded-2xl", `bg-${__props.color}-100 text-${__props.color}-600`])
    }, _toDisplayString(__props.text), 3),
    _cache[0] || (_cache[0] = _createStaticVNode("<div class=\"sr-only text-red-600\"></div><div class=\"sr-only text-violet-600\"></div><div class=\"sr-only text-blue-600\"></div><div class=\"sr-only text-yellow-600\"></div><div class=\"sr-only text-green-600\"></div>", 5))
  ], 64))
}
}

})